import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { moduleGuard } from './core/guards/module.guard';
import { roleGuard } from './core/guards/role.guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes').then((m) => m.authRoutes),
  },
  {
    path: 'super-admin',
    loadChildren: () => import('./features/super-admin/super-admin.routes').then((m) => m.superAdminRoutes),
  },
  {
    path: 'loja/:slug',
    loadComponent: () =>
      import('./features/public-booking/booking.component').then((m) => m.BookingComponent),
  },
  {
    path: 'aggendai',
    pathMatch: 'full',
    loadComponent: () => import('./features/landing/landing.component').then((m) => m.LandingComponent),
  },
  { path: '', pathMatch: 'full', redirectTo: 'aggendai' },
  {
    path: '',
    canActivate: [authGuard],
    canActivateChild: [roleGuard],
    loadComponent: () => import('./layout/shell.component').then((m) => m.ShellComponent),
    children: [
      // área do profissional (login com usuário e senha)
      { path: 'meus-agendamentos', loadComponent: () => import('./features/professional-area/my-appointments.component').then((m) => m.MyAppointmentsComponent) },
      { path: 'perfil', loadComponent: () => import('./features/professional-area/profile.component').then((m) => m.ProfileComponent) },
      { path: 'dashboard', loadComponent: () => import('./features/dashboard/dashboard.component').then((m) => m.DashboardComponent) },
      { path: 'agenda', loadComponent: () => import('./features/agenda/agenda.component').then((m) => m.AgendaComponent) },
      { path: 'clientes', canActivate: [moduleGuard('Crm')], loadComponent: () => import('./features/clients/clients.component').then((m) => m.ClientsComponent) },
      { path: 'servicos/horarios', loadComponent: () => import('./features/schedule/schedule.component').then((m) => m.ScheduleComponent) },
      { path: 'servicos',loadComponent: () => import('./features/services/services.component').then((m) => m.ServicesComponent) },
      { path: 'profissionais', loadComponent: () => import('./features/professionals/professionals.component').then((m) => m.ProfessionalsComponent) },
      { path: 'financeiro', canActivate: [moduleGuard('Financial')], loadComponent: () => import('./features/financial/financial.component').then((m) => m.FinancialComponent) },
      { path: 'fidelidade', canActivate: [moduleGuard('Loyalty')], loadComponent: () => import('./features/loyalty/loyalty.component').then((m) => m.LoyaltyComponent) },
      { path: 'promocoes', canActivate: [moduleGuard('Campaigns')], loadComponent: () => import('./features/promotions/promotions.component').then((m) => m.PromotionsComponent) },
      { path: 'whatsapp', loadComponent: () => import('./features/whatsapp/whatsapp.component').then((m) => m.WhatsappComponent) },
      { path: 'comunicacoes', canActivate: [moduleGuard('WhatsAppReminders')], loadComponent: () => import('./features/communications/communications.component').then((m) => m.CommunicationsComponent) },
      { path: 'suporte', loadComponent: () => import('./features/support/support.component').then((m) => m.SupportComponent) },
      { path: 'empresa', loadComponent: () => import('./features/company/company.component').then((m) => m.CompanyComponent) },
      { path: 'faturas', loadComponent: () => import('./features/billing/billing.component').then((m) => m.BillingComponent) },
      { path: 'meu-plano', loadComponent: () => import('./features/plan/plan.component').then((m) => m.PlanComponent) },
      { path: 'config',loadComponent: () => import('./features/config/config.component').then((m) => m.ConfigComponent) },
    ],
  },
  { path: '**', redirectTo: 'aggendai' },
];
